import React from "react";

import CmsPreviewShell from "./CmsPreviewShell";

const GalleryComponent = ({ title, subtitle, layout, items = [] }) => {
  return (
    <CmsPreviewShell title={title} subtitle={subtitle}>
      <div className={`cms-gallery cms-gallery--${layout}`}>
        {items.map((item) => (
          <div key={item.id} className="cms-gallery__item">
            <div className="cms-gallery__thumb">
              <img src={item.img} alt={item.caption} />
              <div className="cms-gallery__overlay">
                <p className="cms-gallery__caption">{item.caption}</p>
                <span className="cms-gallery__author">{item.author}</span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </CmsPreviewShell>
  );
};

export default GalleryComponent;
